<div class="row">
  <div class="col">
    <div class="card">
      <div class="card-header">
        <h3>{{'lang.globals.permissions' | translate}}</h3>
        <div class="header-more">
          <nav ngbNav #nav="ngbNav" class="nav-tabs">
            <ng-container ngbNavItem>
              <a ngbNavLink>
                <sb-icon icon="key" class="mr-2"></sb-icon>
                {{'lang.globals.permissions' | translate}}
              </a>
              <ng-template ngbNavContent>
                <div class="row" *ngFor="let category of permissionCategories; last as last">
                  <div class="col">
                    <ul class="list-group">
                      <li class="list-group-item active">
                        <b>{{'lang.permissionGroups.' + category | translate}}</b>
                      </li>
                      <li class="list-group-item" *ngFor="let permission of categories[category]">
                        {{'permission.' + permission | translate}}
                      </li>
                    </ul>
                    <hr *ngIf="!last" class="border-dashed">
                  </div>
                </div>
                <!-- <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 mb-4" *ngFor="let category of permissionCategories; last as last">
                        <ul class="list-group">
                            <li class="list-group-item active">
                                <b>{{'lang.permissionGroups.' + category | translate}}</b>
                            </li>
                            <li class="list-group-item" *ngFor="let permission of categories[category]">
                                {{'permission.' + permission | translate}}
                            </li>
                        </ul>
                    </div>
                </div> -->
                <!-- <div class="row">
                    <div class="col" *ngFor="let chunk of permissionCategoriesChunked">
                        <div class="row" *ngFor="let category of chunk; last as last">
                            <div class="col">
                                <ul class="list-group">
                                    <li class="list-group-item active">
                                        <b>{{'lang.permissionGroups.' + category | translate}}</b>
                                    </li>
                                    <li class="list-group-item" *ngFor="let permission of categories[category]">
                                        {{'permission.' + permission | translate}}
                                    </li>
                                </ul>
                                <hr *ngIf="!last" class="border-dashed">
                            </div>
                        </div>
                    </div>
                </div> -->
              </ng-template>
            </ng-container>
          </nav>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col">
            <div [style.minHeight]="'400px'" style="overflow-x: hidden;">
              <div [ngbNavOutlet]="nav"></div>
            </div>
            <!-- <ng-scrollbar style="width: 100%;" [style.minHeight]="'400px'" [style.maxHeight]="'700px'"
                [config]="{suppressScrollX: true}">
                <div [ngbNavOutlet]="nav"></div>
            </ng-scrollbar> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
